import { Helmet } from "react-helmet-async";
import { styled } from '@mui/material/styles';
import { Container, Tabs, Tab, Grid } from '@mui/material';
import { ChangeEvent, useState } from "react";
import PageTitleWrapper from "src/components/PageTitleWrapper";
import PageHeader from "../common/PageHeader";
import TownshipDetails from "./TownshipDetails/TownshipDetails";
import SubscriptionDetails from "./SubscriptionDetails/SubscriptionDetails";
import { useSelector } from "react-redux";
import { RootState } from "src/redux-store/appStore";

const TabsWrapper = styled(Tabs)(
    () => `
      .MuiTabs-scrollableX {
        overflow-x: auto !important;
      }
  `
  );
  
const TownshipManagement: React.FC = () => {
  // Default tab logic
  const defaultTab = 'township_details';
  const [currentTab, setCurrentTab] = useState<string>(defaultTab);
  const userData = useSelector((state: RootState) => state.user.userDetails);
  const user = {
    name: `${userData.FirstName} ${userData.LastName}`,
    jobTitle: userData.UserRole === 'Vendor' ? 'User' : userData.UserRole,
  };

  const tabs = [
    { value: 'township_details', label: 'Township Details' },
    { value: 'subscription_details', label: 'Subscription Details' },
  ];

  // Handle tab change
  const handleTabsChange = (event: ChangeEvent<unknown>, value: string): void => {
    setCurrentTab(value);
  };

  return (
    <>
      <Helmet>
        <title>Township Management</title>
      </Helmet>
      <PageTitleWrapper>
      <PageHeader
        userName={user.name}
        jobTitle={user.jobTitle}
        pageTitle='Township Management'
        description=''
      />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <TabsWrapper
              onChange={handleTabsChange}
              value={currentTab}
              variant="scrollable"
              scrollButtons="auto"
              textColor="primary"
              indicatorColor="primary"
            >
              {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </TabsWrapper>
          </Grid>
          <Grid item xs={12}>
            {currentTab === 'township_details' && <TownshipDetails />}
            {currentTab === 'subscription_details' && <SubscriptionDetails />}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default TownshipManagement